export const DEFAULT_PROFILE_IMAGE = '/images/avatars/default.png';
export const DEFAULT_DOG_PROFILE_IMAGE = '/images/avatars/dog_default.png';

/**
 * @enum {string} Profile image urls map. Key is the image version, value is the image url.
 */
export const PROFILE_IMAGE_VERSION = {
    PROFILE: 'PROFILE',
    PROFILE_FRIEND: 'PROFILE_FRIEND',
    PROFILE_THUMBNAIL: 'PROFILE_THUMBNAIL',
    FRAMED_PROFILE: atob('RlJBTUVEX1BST0ZJTEU='),
    FRAMED_FRIEND: atob('RlJBTUVEX0ZSSUVORA=='),
    FRAMED_THUMBNAIL: atob('RlJBTUVEX1RIVU1CTkFJTA=='),
    PREMIUM_PROFILE: atob('UFJFTUlVTV9QUk9GSUxF'),
    PREMIUM_FRIEND: atob('UFJFTUlVTV9GUklFTkQ='),
    PREMIUM_THUMBNAIL: atob('UFJFTUlVTV9USFVNQk5BSUw=')
};

export const imageVersionQueryString = Object.values(PROFILE_IMAGE_VERSION)
    .map((item) => `image-version=${item}`)
    .join('&');

export const fullImageVersions = [
    PROFILE_IMAGE_VERSION.PROFILE,
    PROFILE_IMAGE_VERSION.FRAMED_PROFILE,
    PROFILE_IMAGE_VERSION.PREMIUM_PROFILE,
    PROFILE_IMAGE_VERSION.PROFILE_FRIEND,
    PROFILE_IMAGE_VERSION.FRAMED_FRIEND,
    PROFILE_IMAGE_VERSION.PREMIUM_FRIEND,
    PROFILE_IMAGE_VERSION.PROFILE_THUMBNAIL,
    PROFILE_IMAGE_VERSION.FRAMED_THUMBNAIL,
    PROFILE_IMAGE_VERSION.PREMIUM_THUMBNAIL
];

export const profileImageVersions = [
    PROFILE_IMAGE_VERSION.PROFILE,
    PROFILE_IMAGE_VERSION.FRAMED_PROFILE,
    PROFILE_IMAGE_VERSION.PREMIUM_PROFILE
];

export const friendImageVersions = [
    PROFILE_IMAGE_VERSION.PROFILE_FRIEND,
    PROFILE_IMAGE_VERSION.FRAMED_FRIEND,
    PROFILE_IMAGE_VERSION.PREMIUM_FRIEND
];

export const thumbnailImageVersions = [
    PROFILE_IMAGE_VERSION.PROFILE_THUMBNAIL,
    PROFILE_IMAGE_VERSION.FRAMED_THUMBNAIL,
    PROFILE_IMAGE_VERSION.PREMIUM_THUMBNAIL
];

export const friendAndThumbnailImageVersions = [
    PROFILE_IMAGE_VERSION.PROFILE_FRIEND,
    PROFILE_IMAGE_VERSION.FRAMED_FRIEND,
    PROFILE_IMAGE_VERSION.PREMIUM_FRIEND,
    PROFILE_IMAGE_VERSION.PROFILE_THUMBNAIL,
    PROFILE_IMAGE_VERSION.FRAMED_THUMBNAIL,
    PROFILE_IMAGE_VERSION.PREMIUM_THUMBNAIL
];

/** image version for non-gcp only */
export const nonGcpImageVersions = [
    PROFILE_IMAGE_VERSION.PROFILE,
    PROFILE_IMAGE_VERSION.PROFILE_FRIEND,
    PROFILE_IMAGE_VERSION.PROFILE_THUMBNAIL
];

export const nonGcpImageVersionQuerystring = nonGcpImageVersions.map((item) => `image-version=${item}`).join('&');
